import { z } from 'zod';

export const TURN_TYPES = {
	turn: 'turn',
	finish: 'finish',
	bonus: 'bonus',
} as const satisfies Record<string, string>;

export type TurnType = (typeof TURN_TYPES)[keyof typeof TURN_TYPES];

export const turnTypesSchema = z.nativeEnum(TURN_TYPES);
